(function () {
    'use strict';

    angular.module("imApp").factory("webpageSubscriptionEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 83,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 84,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
